import React from 'react';
import { Aviso } from '~/components/Aviso';

export default function Login() {
  return (
    <>
      <Aviso />
    </>
  );
}
